import { IconProps } from '@velocity-exchange/icons';
import { cj } from 'src/utils/classNames';

export default function OKX({
	className,
	color,
	size = 16,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				fill="none"
				viewBox="0 0 24 24"
			>
				<path
					fill={color ?? 'currentColor'}
					d="M15.463 8H8.53a.533.533 0 0 0-.533.534v6.933c0 .294.239.533.533.533h6.933a.533.533 0 0 0 .533-.533V8.534A.533.533 0 0 0 15.463 8M7.466 0H.533A.533.533 0 0 0 0 .533v6.934C0 7.76.239 8 .533 8h6.933a.533.533 0 0 0 .533-.533V.533A.533.533 0 0 0 7.466 0M23.467 0h-6.933a.533.533 0 0 0-.533.533v6.934c0 .294.239.533.533.533h6.933A.533.533 0 0 0 24 7.467V.533A.533.533 0 0 0 23.467 0M7.466 16H.533a.533.533 0 0 0-.533.533v6.934c0 .294.239.533.533.533h6.933a.534.534 0 0 0 .533-.533v-6.934A.533.533 0 0 0 7.466 16M23.467 16h-6.933a.533.533 0 0 0-.533.533v6.934c0 .294.239.533.533.533h6.933a.533.533 0 0 0 .533-.533v-6.934a.533.533 0 0 0-.533-.533"
				/>
			</svg>
		</span>
	);
}
